import { createSlice } from "@reduxjs/toolkit";

const websocketSlice = createSlice({
  name: "websocket",
  initialState: {
    currentMatterId: null,
    currentFolderId: null, // only one folder tracked
    annotationUpdate: null, // Store incoming annotation updates
    documentContentUpdate: null, // Store incoming document content updates (e.g., letterhead)
    notificationRefreshTrigger: 0, // Trigger to refresh notifications
    isConnected: false, // Live socket state, so views can fall back to polling
    vaStatusUpdatedAt: 0, // Trigger for views showing a single VA submission
    // Latest AI Processing Dashboard snapshot the server has published. The
    // nudge carries no dashboard data (that socket is unauthenticated), so
    // the dashboard re-reads its admin-gated endpoint when this moves.
    pipelineDashboardGeneration: 0,
  },
  reducers: {
    setCurrentContext: (state, action) => {
      const { matterId, folderId } = action.payload;

      if (matterId !== undefined) {
        state.currentMatterId = matterId;
      }
      if (folderId !== undefined) {
        state.currentFolderId = folderId;
      }
    },
    setAnnotationUpdate: (state, action) => {
      state.annotationUpdate = action.payload;
    },
    clearAnnotationUpdate: (state) => {
      state.annotationUpdate = null;
    },
    setDocumentContentUpdate: (state, action) => {
      state.documentContentUpdate = action.payload;
    },
    clearDocumentContentUpdate: (state) => {
      state.documentContentUpdate = null;
    },
    triggerNotificationRefresh: (state) => {
      state.notificationRefreshTrigger = Date.now();
    },
    setSocketConnected: (state, action) => {
      state.isConnected = Boolean(action.payload);
    },
    markVaStatusUpdated: (state) => {
      state.vaStatusUpdatedAt = Date.now();
    },
    markPipelineDashboardUpdated: (state, action) => {
      // Fall back to a clock value when the server omits a generation, so
      // the dashboard still sees a change and re-reads.
      const generation = Number(action.payload);
      state.pipelineDashboardGeneration = Number.isFinite(generation) && generation > 0
        ? generation
        : Date.now();
    },
  },
});

export const { setCurrentContext, setAnnotationUpdate, clearAnnotationUpdate, setDocumentContentUpdate, clearDocumentContentUpdate, triggerNotificationRefresh, setSocketConnected, markVaStatusUpdated, markPipelineDashboardUpdated } = websocketSlice.actions;
export default websocketSlice.reducer;
